import type { RangeResult } from "schemas/generated/analyticsRead";
import type { Insight } from "schemas/generated/insights";

export const FAKE_INSIGHT: Insight = {
  id: crypto.randomUUID(),
  title: "Increased Engagement on Homepage",
  analysis:
    "Your homepage has shown a 25% increase in user engagement over the past week, particularly in the hero section.",
  action:
    "Consider A/B testing different hero section layouts to further optimize engagement.",
  actionTitle: "Create A/B Test",
  actionPrompt: "Would you like to start an A/B test for your hero section?",
  actionType: "buildInEditor",
  sentiment: "positive",
  reference: "homepage-hero-section",
  url: "https://www.google.com/some-page",
  elementId: "hero-section-container",
  projectId: null,
};

export function generateFakeChartDataRangeResult(): RangeResult {
  return {
    urlPath: "some_domain.com",
    metadata: {
      elementId: null,
      title: "Some random title",
      url: "https://www.google.com/some-page",
    },
    rangeId: "f13ffb7f-ea60-474c-a3dd-669070b5f8a2",
    metrics: {
      views: Array.from({ length: 168 }, () =>
        Math.floor(Math.random() * 1500 + 200),
      ),
      unique_sessions: Array.from({ length: 168 }, () =>
        Math.floor(Math.random() * 600 + 50),
      ),
      conversions: Array.from({ length: 168 }, () =>
        Math.floor(Math.random() * 35 + 1),
      ),
      revenue: Array.from({ length: 168 }, () =>
        Number((Math.random() * 2500 + 100).toFixed(2)),
      ),
      conversion_rates: Array.from({ length: 168 }, () =>
        Number((Math.random() * 8 + 1).toFixed(2)),
      ),
      average_order_value: Array.from({ length: 168 }, () =>
        Number((Math.random() * 100 + 25).toFixed(2)),
      ),
      revenue_per_session: Array.from({ length: 168 }, () =>
        Number((Math.random() * 5 + 0.5).toFixed(2)),
      ),
    },
  };
}
